import CardSystem from '../CardSystem';
import ITask from '../../../Utility/Task/ITask';
import Game from '../../../Game';
import GameObject from '../../../GameObject/GameObject';
import Point from '../../../Utility/Point';
import StreakTextEffect from '../../../Prototype/Effect/StreakTextEffect';

export default class StreakTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        if (!system.store.getState().levelState.cardsState.streakEnabled) {
            return;
        }

        const streak = system.store.getState().levelState.cardsState
            .matchSequence.length;

        if (streak === 3 || streak === 8 || streak % 5 === 0) {
            const key =
                streak === 3
                    ? 'Nice'
                    : streak === 8
                    ? 'Amazing'
                    : 'BonusStreak';

            system.scene.addGameObject(
                GameObject.Instantiate(StreakTextEffect, {
                    text: Game.locale.getText(key),
                    anchor: new Point(0.5, 0.5),
                    relativePosition: new Point(0.5, 0.5),
                    position: new Point(0, 0),
                    alpha: 0,
                })
            );
        }
    }
}
